import { render, staticRenderFns } from "./costManagementNumDetail.vue?vue&type=template&id=f2e92f40&scoped=true&"
import script from "./costManagementNumDetail.vue?vue&type=script&lang=js&"
export * from "./costManagementNumDetail.vue?vue&type=script&lang=js&"
import style0 from "./costManagementNumDetail.vue?vue&type=style&index=0&id=f2e92f40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e92f40",
  null
  
)

export default component.exports